// @ts-nocheck TODO

import {html, nothing} from "lit";
import {customElement, property, state} from "lit/decorators.js";
import {styleMap} from "lit/directives/style-map.js";
import "../../common/controls-inputs/rich-text-editor/RichTextEditor.js";
import {MobxLitElement} from "@adobe/lit-mobx";
import {annotationUuid} from "../../../main/data/model/index.js";

import "../../common/controls-inputs/Dropdown.js";
import "../../common/controls-inputs/DropdownItem.js";
import "../../common/controls-inputs/DropdownSubmenu.js";

import Data from "../../../main/data/index.js";

// TODO: dropdown renderHelper/isTouched doesn't seem to be working

@customElement("pn-annotation-menu")
export class AnnotationMenu extends MobxLitElement {
	@property() annotationUuid: annotationUuid;

	@state() isLoaded = false;

	projectUuid = Data.app.project?.uuid;

	protected createRenderRoot(): HTMLElement | DocumentFragment {
		return this;
	}

	getMoveToTopicButtons = () => {
		const topicUuid = Data.outline.getTopicUuidForAnnotation(this.annotationUuid, this.projectUuid);

		return Data.app.topics
			.filter(topic => topic.uuid !== topicUuid)
			.map(topic => html`<pn-dropdown-item
				.onClick=${() => Data.annotation.moveToTopic(this.annotationUuid, this.projectUuid, topic.uuid)}
				type="button"
			>
				<i
					class="icon-circle icon-mask"
					style=${styleMap({
						"backgroundColor": "#" + topic.color
					})}
				></i>
				<span class="dropdown-text dropdown-text-topic">
					${topic.label}
				</span>
			</pn-dropdown-item>`);
	};

	getProjectTopicsBtnsCopy = (projectUuid, projectTopics) => {
		return projectTopics.map(topic => {
			return html`<pn-dropdown-item
				.onClick=${() => {
					Data.app.backend.copyAnnotationToProject(this.annotationUuid, projectUuid, topic.uuid);
				}}
				type="button"
			>
				<i
					class="icon-circle icon-mask"
					style=${styleMap({
						"backgroundColor": "#" + topic.color
					})}
				></i>
				<span class="dropdown-text dropdown-text-topic">
					${topic.label}
				</span>
			</pn-dropdown-item>`;
		});
	};

	getCopyToProjectButtons = () => {
		return []; // TODO: find a way to do this without fully loading every project in Data (anything more than a few projects and things crash badly)
		// eslint-disable-next-line no-unreachable
		return Data.project.all.map(project => {
			return html`<pn-dropdown-item
				type="submenu"
			>
				<span>${project.name}</span>
				<pn-dropdown-submenu slot="submenu">
					${this.getProjectTopicsBtnsCopy(project.uuid, [])}
				</pn-dropdown-submenu>
			</pn-dropdown-item>`;
		});
	};

	render() {
		const showWebAppLinks = !!(Data.app.me?.email);
		const projectTopicsUrl = showWebAppLinks
			? Data.app.getWebAppAuthLink(`project/${this.projectUuid}/outline#topics`)
			: null;
		const moveToTopicButtons = this.getMoveToTopicButtons();
		const copyToProjectButtons = this.getCopyToProjectButtons();

		return html`
			<pn-dropdown
				id="dropdown-id"
				.isDropdown="${true}"
				.tooltipOptions="${{
					position: "top",
					text:     "Card Actions"
				}}"
			>
				<pn-dropdown-item
					.onClick=${() => {
						Data.annotation.delete(this.annotationUuid, this.projectUuid);
					}}
					type="button"
				>
					Delete
				</pn-dropdown-item>
				${moveToTopicButtons.length > 0 || showWebAppLinks ? html`
					<pn-dropdown-item type="submenu">
						Move to Topic
						<pn-dropdown-submenu slot="submenu">
							${moveToTopicButtons}
							${showWebAppLinks ? html`<pn-dropdown-item
								.classNames=${"link-add-topic"}
								.href=${projectTopicsUrl}
								type="link"
							>
								<i class="icon-add icon-mask add-topic"></i>
								add new topic
							</pn-dropdown-item>` : nothing}
						</pn-dropdown-submenu>
					</pn-dropdown-item>`
				: nothing}

				${copyToProjectButtons.length > 0 ? html`
					<pn-dropdown-item type="submenu">
						Copy to Project
						<pn-dropdown-submenu slot="submenu">
							${copyToProjectButtons}
						</pn-dropdown-submenu>
					</pn-dropdown-item>`
				: nothing}
			</pn-dropdown>
		`;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		"pn-annotation-menu": AnnotationMenu;
	}
}
